<template>
  <a-spin :spinning="loading">
    <div class="spin-content">
      <div class="wrapper">
        <a-row :gutter="16">
          <a-col :span="14">
            <div class="student">
              <a-avatar
                :src="student.avatar_preview"
                :size="48"
                shape="square"
                icon="user"
                class="student__avatar"
              />
              <h2 class="student__name">
                {{ student.full_name }}
              </h2>
            </div>

            <h3 v-if="student.certificates.length">Certyfikaty</h3>
            <ul>
              <li
                v-for="certificate in student.certificates"
                :key="certificate.code"
              >
                <a :href="certificate.url">{{ certificate.name }}</a>
              </li>
            </ul>

            <h3 v-if="student.education || student.bio">
              Wykształcenie i biogram:
            </h3>
            <p v-text="student.education" />
            <p v-text="student.bio" />

            <h3>Kontakt</h3>
            <ul class="contact-list">
              <icon-with-text v-if="student.email" tag="li" icon="mail">
                <a :href="`mailto:${student.email}`">{{ student.email }}</a>
              </icon-with-text>

              <icon-with-text tag="li" icon="message">
                <a @click="() => openDirectChat(student.id)">
                  Chat
                </a>
              </icon-with-text>

              <icon-with-text
                tag="li"
                v-if="student.skype_username"
                icon="skype"
              >
                <a :href="`skype:${student.skype_username}?chat`">
                  {{ student.skype_username }}
                </a>
              </icon-with-text>

              <icon-with-text tag="li" v-if="student.phone_number" icon="phone">
                <a :href="`tel:${student.phone_number}`">
                  {{ student.phone_number }}
                </a>
              </icon-with-text>
            </ul>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-divider v-if="withDivider" />
  </a-spin>
</template>

<script>
import { Student } from '@/api'
import IconWithText from '@/components/common/IconWithText'

export default {
  components: {
    IconWithText
  },
  data() {
    return {
      student: {},
      loading: false
    }
  },
  props: {
    studentId: {
      type: [Number, String],
      required: true
    },
    withDivider: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      Student.get(this.studentId)
        .then(res => {
          this.student = res.data
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.student {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  &__name {
    margin-bottom: 0;
  }

  &__avatar {
    margin-right: 16px;
  }
}
</style>
